import { render, staticRenderFns } from "./Heimevernet.vue?vue&type=template&id=973ef840&"
import script from "./Heimevernet.vue?vue&type=script&lang=js&"
export * from "./Heimevernet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports